import { render, staticRenderFns } from "./BattleParticipantRow.vue?vue&type=template&id=108d158a&scoped=true"
import script from "./BattleParticipantRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./BattleParticipantRow.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BattleParticipantRow.vue?vue&type=style&index=0&id=108d158a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108d158a",
  null
  
)

export default component.exports